<template lang="pug">
.has-found-item(@click="goDetail")
  .avtar
    img(:src="detail.childUrl"
    style="height: 0.84rem; width: 0.64rem;"
    )
  .info
    .name {{detail.childName}}
    .age {{detail.childAge}}岁
  .found-icon
    img(
      src="https://m.hellobike.com/resource/helloyun/12399/d6RK6_found.png?x-oss-process=image/quality,q_80"
      style="width:0.66rem; height:0.6rem"
    )
</template>

<script>
import router from '../../../router';
import { UBTUtils } from '../../../utils/ubt';

export default {
  name: 'HasFoundItem',
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    goDetail() {
      const query = {
        caseId: this.detail.caseId,
      };
      router.push({
        path: 'reunion/detail',
        query,
      });
      UBTUtils.clickButton({
        pageId: 'platform_tuanyuan_list',
        buttonName: 'platform_tuanyuan_click_case',
        categoryId: 'platform',
        businessInfo: {},
      });
    },
  },
};
</script>

<style lang="less" scoped>
.has-found-item {
  padding: 0.16rem;
  background: #fff;
  display: inline-flex;
  width: 100%;
  position: relative;

  .avtar {
    width: 0.64rem;
    height: 0.84rem;
  }

  .info {
    padding: 0.01rem 0 0 0.12rem;

    .name {
      height: 22px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-weight: 500;
      color: #242729;
      line-height: 22px;
      margin-bottom: 0.12rem;
    }

    .age {
      height: 17px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-weight: 400;
      color: #242729;
      line-height: 17px;
    }
  }

  .found-icon {
    position: absolute;
    right: 0;
    padding: 0.11rem 0.31rem 0 0;
  }
}

</style>
